const PLACEHOLDER_CLUES = new Set([
    "a word to find in this puzzle.",
    "used in this puzzle's story.",
]);

export function parseWordsInUse(wordsInUse) {
    return String(wordsInUse || "")
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n")
        .split(/[\n,;]+/)
        .map((word) => word.trim())
        .filter(Boolean);
}

export function isPlaceholderDisplayClue(definition) {
    const trimmed = String(definition || "").trim();
    if (!trimmed) return true;
    return PLACEHOLDER_CLUES.has(trimmed.toLowerCase());
}

function definitionByWordLower(displayClue) {
    const out = new Map();
    if (!Array.isArray(displayClue)) return out;
    displayClue.forEach((row) => {
        const word = String(row?.word || "").trim().toLowerCase();
        if (!word || isPlaceholderDisplayClue(row?.definition)) return;
        if (!out.has(word)) {
            out.set(word, String(row.definition).trim());
        }
    });
    return out;
}

/** Words in the puzzle that do not yet have a real display clue. */
export function missingClueWords(row) {
    const words = parseWordsInUse(row?.wordsInUse);
    const defs = definitionByWordLower(row?.displayClue);
    return words.filter((word) => !defs.has(word.toLowerCase()));
}
